import React, { Component } from "react";

import Mapa from '../../../assets/images/imagem-mapa.svg';

export default class ItemChart extends Component {
	
	onDelete = () => {
		this.props.onDelete(this.props.item);
	}

	onEdit = () => {
		this.props.onEdit(this.props.item);
	}

	render() {
		return (
			<div className="item-chart">
				<div className="item-chart--header">
					<span className="item-chart--header-text">
						{this.props.item.person_name || "Sem identificação"}
					</span>
					<span className="item-chart--header-icon" onClick={this.onDelete}>
						<i className="fa fa-times" />
					</span>
				</div>
				<div className="item-chart--content">
					<img className="item-chart--content-image" src={Mapa} alt="Simbolo do mapa" />
				</div>
				<div className="item-chart--footer-left">
					<span>
						# {this.props.item.category ? this.props.item.category.name : 'Sem categoria'}
					</span>
				</div>
				<div className="item-chart--footer-right" onClick={this.onEdit}>
					<span>
						Editar
					</span>
				</div>
			</div>
		);
	}
}
